import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrCheckbox } from "../../inputs";
import { GrStack } from "../../layout";
import { palette } from "../../../theme/palette";
import { typography } from "../../../theme/typography";
import styled from "@emotion/styled";
import { DataGrid, } from "@mui/x-data-grid";
import classNames from "classnames";
const StyledTableWrapper = styled("div")(({ style, size }) => ({
    ".MuiDataGrid-root": {
        border: "none",
    },
    ".MuiDataGrid-topContainer": {
        ...typography["Content.Subtitle04"],
    },
    ".MuiDataGrid-topContainer::after": {
        backgroundColor: palette.grey025,
    },
    ".MuiDataGrid-columnHeaders": {
        borderBottom: `1px solid ${palette.grey025}`,
        ".MuiDataGrid-columnHeaderTitleContainerContent": {
            ...typography["Content.Subtitle04"],
        },
    },
    ".MuiDataGrid-cell:focus": {
        outline: "none",
    },
    ".MuiDataGrid-cell:focus-within": {
        outline: "none !important",
    },
    ".MuiDataGrid-cell": {
        display: "table-cell",
        verticalAlign: "middle !important",
        borderTop: `1px solid ${palette.grey020} !important`,
        padding: size === "auto" ? "4px 0" : undefined,
        ...typography["Content.Body04"],
    },
    ".MuiDataGrid-row": {
        display: "table-row",
        "&[data-rowindex='0']": {
            ".MuiDataGrid-cell": {
                borderTop: "0 !important",
            },
        },
    },
    ".MuiDataGrid-row--firstVisible": {
        ".MuiDataGrid-cell": {
            borderTop: "0 !important",
            borderBottom: "0",
        },
    },
    ".Mui-selected": {
        backgroundColor: `${palette.blue015} !important`,
    },
    ".MuiDataGrid-filler": {
        height: "0 !important",
    },
    ".disabled": {
        color: palette.grey030,
    },
    backgroundColor: palette.white,
    padding: "0 0 24px",
    color: palette.grey090,
    ...style,
}));
const StyledRppText = styled("span")(() => ({
    ...typography["Content.Body04"],
    color: palette.grey080,
}));
export function GrTable({ headerData, cellData, style, header, noRowsOverlay, loadingOverlay, 
// disableColumnSorting = true,
hasRppSelect = false, size = "medium", isRowSelectable, className, 
// rppOptions,
// onRppChange,
// eslint-disable-next-line @typescript-eslint/no-unused-vars
lang, ...props }) {
    return (_jsxs(StyledTableWrapper, { className: "GrTable-wrapper", style: style, size: size, children: [(hasRppSelect || !!header) && (_jsxs(GrStack, { justifyContent: "space-between", padding: "24px 16px 0", children: [_jsx("div", { children: header }), hasRppSelect && (_jsxs(GrStack, { gap: "8px", children: [_jsx(StyledRppText, { children: "View" }), _jsx("span", { children: "Select" }), _jsx(StyledRppText, { children: "Rows" })] }))] })), _jsx(DataGrid, { className: classNames("GrTable", className), rows: cellData, columns: headerData, hideFooter: true, slots: {
                    columnMenuIcon: () => null,
                    baseCheckbox: checkProps => _jsx(GrCheckbox, { ...checkProps, size: "medium", type: "rectangle" }),
                    noRowsOverlay: noRowsOverlay ? () => noRowsOverlay : undefined,
                    loadingOverlay: loadingOverlay ? () => loadingOverlay : undefined,
                }, 
                // TODO: node 14 대응으로 인해 기능 중지
                // disableColumnSorting={disableColumnSorting}
                getRowClassName: isRowSelectable ? params => (isRowSelectable(params) === false ? "disabled" : "") : undefined, getRowHeight: () => (size === "small" && 36) || (size === "medium" && 52) || (size === "large" && 64) || "auto", ...props })] }));
}
//# sourceMappingURL=GrTable.js.map